import {IState, TActions} from '../types/user'

export const userReducer = (state: IState, action: TActions): IState => {
  switch (action.type) {
    case 'logout':
      return {
        idOrganization: null,
        user: null,
        statusUser: 'no-user',
      }

    case 'login':
      return {
        statusUser: 'user',
        user: action.paylaod,
        idOrganization: null,
      }
    case 'updateOrganization':
      return {
        ...state,
        idOrganization: action.payload,
      }
    case 'checking':
      return {
        statusUser: 'checking',
        idOrganization: null,
        user: null,
      }
    default:
      return state
  }
}
